import React, { useEffect, useState } from 'react';
import Header from './Header.js';
import Footer from './Footer.js';
import NewsletterSubscription from './NewsletterSubscription.js';
import HistoryTimeline from './HistoryTimeline.js';
import AnimatedHexagonBackground from './AnimatedHexagonBackground.js';
import SmartSurfaceScience from './smart-surface-science.js';
import AboutTechnology from './about-technology.js';
import PhilosophySection from './philosophy-section.js';
import Picture from './components/Picture.jsx';

const AboutPage = () => {
  const [isZoomedOut, setIsZoomedOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsZoomedOut(true), 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="font-bai-jamjuree text-gray-800 bg-black">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative py-52 px-4 overflow-hidden min-h-[130vh] md:min-h-screen">
          <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
            <div
              className="absolute inset-0 will-change-transform"
              style={{
                transform: isZoomedOut ? 'scale(1)' : 'scale(1.2)',
                transition: 'transform 12s ease-out'
              }}
            >
              <Picture
                src="/images/background/paint-protection-image-min-1-scaled.webp"
                fallbackExt="png"
                alt=""
                pictureClassName="block h-full w-full"
                className="h-full w-full object-cover"
              />
            </div>
          </div>
          <div className="absolute inset-0 bg-complex-non-linear-gradient"></div>
        
          <div className="container mx-auto mt-0 md:mt-28 relative z-10 h-full flex flex-col justify-center">
            <div className="md:w-1/2">
              <div className="inline-block mb-4 relative">
                <div className="relative">
                  <span className="bg-[#ff0000] text-white font-semibold px-4 py-1 inline-block relative z-10">
                    Sobre Nós
                  </span>
                  <span 
                    className="absolute top-0 right-0 bottom-0 bg-[#ff0000] transform -skew-x-12" 
                    style={{ 
                      width: '20px',
                      transformOrigin: 'bottom right'
                    }}
                  ></span>
                </div>
              </div> 

              <h1 className="text-4xl md:text-5xl md:text-5xl text-center md:text-left font-bold mb-6 text-white">Fruto De Pura Ciência</h1>
              <p className="text-lg md:text-xl mb-8 text-white text-center md:text-left">
                A Gtechniq foi fundada pelo físico quântico Drew Gill em 2001, devido à total insatisfação com o desempenho dos produtos de proteção de pintura disponíveis na época.
              </p>
              <p className="text-lg md:text-xl mb-8 text-white text-center md:text-left">
                Desde ceras até polímeros inovadores e tratamentos baseados em PTFE, nada no mercado oferecia durabilidade significativa, seja na aparência ou na proteção. Pior ainda, ele descobriu que a maioria dos produtos na verdade tinha um desempenho inferior às próprias pinturas que deveriam proteger.
              </p>
              <a href="#history" className="hidden md:inline-block bg-[#ff0000] text-white mb-24 px-8 py-3 font-semibold">
                Nossa História
              </a>
            </div>
          </div>
          <div className="absolute inset-x-0 -bottom-24 md:bottom-0 md:inset-y-0 md:left-1/2 md:w-1/2 h-1/2 md:h-auto overflow-visible">
            <AnimatedHexagonBackground />
          </div>
        </section>


         {/* It Started With An Idea Section */}
        <section><div><SmartSurfaceScience /></div></section> 
               
        {/* Technology Behind The Science Section */}
        <AboutTechnology />
        
        {/* Our History Section */}
        <section id="history" className="bg-white py-16 px-4">
          <div className="container mx-auto">
            
            <HistoryTimeline />
          </div>
        </section>

        {/* Philosophy Section */}
        <PhilosophySection />


      </main>
      <NewsletterSubscription />
      <Footer />
    </div>
  );
};

export default AboutPage;
